import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import config from "./config/environment";
import "./styles/globals.css";

// Drive the browser tab title from the configured app name (runtime env-config
// or VITE_APP_NAME), instead of the static <title> in index.html.
document.title = config.app.name;

// Create root element
const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
